import { COMPANY_LOCAL_TAG, TOKEN_NAME } from '@/constant/config'

export default {
  // 用户主要信息，不包含token
  userInfo: state => state.userInfo ? state.userInfo : JSON.parse(localStorage.getItem(TOKEN_NAME)),
  userData: (state, getters) => {
    const userInfo = getters.userInfo
    if (userInfo && userInfo.User) {
      return userInfo.User
    }
    return undefined
  },
  isLogin: state => {
    return state.userInfo && state.userInfo.User
  },
  companyInfo: state => {
    if (state.companyInfo) {
      return state.companyInfo
    } else {
      const companyInfo = localStorage.getItem(COMPANY_LOCAL_TAG)
      if (companyInfo) {
        state.companyInfo = JSON.parse(companyInfo)
      }
    }
    return state.companyInfo || {}
  },
  companyId: state => {
    return state.companyInfo.id
  }
}
